export interface TextAreaProps {
  field: string
  placeholder: string
  required?: boolean
  onChange: (field: string, value: string, isValid: boolean) => void
  className?: string
  revalidate: boolean
}

export type TextAreaState = {
  value: string
  isValid: boolean
  touched: boolean
}

export enum ActionTypes {
  TEXTAREA_CHANGE = 'TEXTAREA_CHANGE',
  TEXTAREA_BLUR = 'TEXTAREA_BLUR'
}

type TextAreaChangeType = {
  type: typeof ActionTypes.TEXTAREA_CHANGE
  value: string
  isValid: boolean
}

type TextAreaBlurType = {
  type: typeof ActionTypes.TEXTAREA_BLUR
}

export type TextAreaActionTypes = TextAreaChangeType | TextAreaBlurType
